import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useScanbuyContext } from "../../providers/ScanbuyContextProvider";

const FreshdeskWidget = () => {
  const { user, isAuthenticated } = useAuth0();
  const { _tenantUuid } = useScanbuyContext();

  useEffect(() => {
    console.log("[Freshdesk] Component mounted - widget script loaded from HTML");
    console.log("[Freshdesk] Widget settings:", window.fwSettings);
    console.log("[Freshdesk] FreshworksWidget function type:", typeof window.FreshworksWidget);

    // Check if widget script tag exists
    const widgetScript = document.querySelector("script[src*=\"freshworks.com/widgets\"]");
    console.log("[Freshdesk] Widget script tag found:", !!widgetScript);

    if (widgetScript) {
      console.log("[Freshdesk] Widget script src:", widgetScript.src);
      console.log("[Freshdesk] Widget script loaded:", widgetScript.loaded);
    }

    // Check DOM for widget elements after delay
    const checkTimer = setTimeout(() => {
      const widgetIframe = document.querySelector("iframe[src*=\"freshworks\"], iframe[src*=\"freshdesk\"]");
      const widgetContainer = document.querySelector("[id*=\"freshworks\"], [id*=\"freshdesk\"]");
      console.log("[Freshdesk] Widget iframe found:", !!widgetIframe);
      console.log("[Freshdesk] Widget container found:", !!widgetContainer);

      if (widgetIframe) {
        console.log("[Freshdesk] iframe display:", window.getComputedStyle(widgetIframe).display);
      }
    }, 3000);

    return () => {
      console.log("[Freshdesk] Component unmounting");
      clearTimeout(checkTimer);
    };
  }, []);

  // This effect sets up prefill when user is authenticated
  useEffect(() => {
    console.log("[Freshdesk] User profile effect, isAuthenticated:", isAuthenticated, "user:", user);

    if (!isAuthenticated || !user?.email) {
      console.log("[Freshdesk] Waiting for user profile...");
      return;
    }

    const userName = user.name || user.email;
    const userEmail = user.email;

    console.log("[Freshdesk] User ready:", userName, userEmail);

    // Simple prefill function
    const prefillWidget = () => {
      console.log("[Freshdesk] Attempting to prefill widget");
      if (typeof window.FreshworksWidget === "function") {
        try {
          window.FreshworksWidget("identify", "ticketForm", {
            name: userName,
            email: userEmail,
          });

          window.FreshworksWidget("prefill", "ticketForm", {
            subject: "Support Request",
            custom_fields: {
              sb_tenant_id: _tenantUuid,
            },
          });
          console.log("[Freshdesk] ✓ Prefill command sent");
        } catch (error) {
          console.error("[Freshdesk] Prefill error:", error);
        }
      } else {
        console.log("[Freshdesk] Widget function not available yet");
      }
    };

    // Wait for widget to be available, then set up prefill
    let attempts = 0;
    const maxAttempts = 20;

    const setupPrefill = () => {
      attempts++;
      console.log(`[Freshdesk] Setup attempt ${attempts}/${maxAttempts}`);

      if (typeof window.FreshworksWidget === "function") {
        console.log("[Freshdesk] Widget function found, setting up event listener");

        try {
          prefillWidget();
          // Prefill when widget opens
          window.FreshworksWidget("on", "widget:opened", function () {
            console.log("[Freshdesk] 🎯 Widget opened event - prefilling");
            prefillWidget();
          });
          console.log("[Freshdesk] ✓ Event listener registered");
        } catch (error) {
          console.error("[Freshdesk] Error setting up listener:", error);
        }
      } else if (attempts < maxAttempts) {
        // Retry
        setTimeout(setupPrefill, 500);
      } else {
        console.warn("[Freshdesk] ⚠️ Widget did not become available after", maxAttempts, "attempts");
      }
    };

    // Start setup after a short delay
    const timer = setTimeout(setupPrefill, 2000);

    return () => {
      clearTimeout(timer);
    };
  }, [isAuthenticated, user, _tenantUuid]);

  return null;
};

export default FreshdeskWidget;
